var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 0C36.7156 0 0 36.7156 0 82C0 127.284 36.7156 164 82 164C127.284 164 164 127.284 164 82C164 36.7156 127.284 0 82 0ZM82 150.898C43.9423 150.898 13.0926 120.048 13.0926 81.9906C13.0926 43.9329 43.9423 13.0832 82 13.0832C120.058 13.0832 150.907 43.9329 150.907 81.9906C150.907 120.048 120.058 150.898 82 150.898Z",
    fill: "#2D86CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.386 77.1291L122.14 72.8587C121.145 72.0516 120.507 70.8878 120.347 69.6114L117.504 45.7819C117.335 44.3647 116.556 43.1165 115.411 42.3187C115.12 42.2812 92.576 33.6279 90.4737 32.7832C90.2297 33.0366 73.0639 36.6969 73.0075 36.6687L71.9658 36.0681C71.9658 36.0681 71.9001 36.0775 71.8719 36.0868C61.8108 38.3393 51.7497 40.5918 41.6886 42.8349C39.2296 43.3887 37.5778 45.7068 37.8593 48.2221C39.6144 63.5484 41.3788 78.8747 43.1339 94.201C43.2465 95.1865 43.6501 96.1157 44.2977 96.8665L71.7968 128.842C73.1671 130.438 75.4008 130.982 77.353 130.213L124.843 111.358C126.645 110.644 127.856 108.936 127.95 107.003L129.198 81.2117C129.273 79.6443 128.597 78.1239 127.377 77.1384L127.386 77.1291Z",
    fill: "url(#paint0_linear_2551_5557)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.851 116.792L100.159 82.9579C100.084 82.4323 98.4224 82.4698 95.8508 82.8828L98.8636 77.1859L93.4388 45.7637L62.2418 53.9665C58.9945 54.8205 56.9766 58.0491 57.6336 61.334L69.2621 117.543L71.4019 128.13C71.4489 128.346 71.5146 128.552 71.5897 128.758C72.3686 130.87 74.7338 131.996 76.883 131.161L102.28 121.222C104.054 120.528 105.114 118.697 104.851 116.792Z",
    fill: "#BCBEC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9042 83.7368L61.1552 59.5038C61.0614 59.0439 61.3335 58.584 61.7746 58.462L90.1654 50.3061C90.6628 50.1654 91.1602 50.4938 91.2541 51.01C92.6525 58.7811 94.0415 66.5522 95.44 74.3139C95.5244 74.7644 95.2617 75.1962 94.8487 75.3369C85.576 78.3684 76.2938 81.3999 67.0211 84.422C66.5236 84.5815 66.0074 84.2624 65.9042 83.7462V83.7368Z",
    fill: "#D1D3D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6241 50.9824L61.4355 59.0538L66.391 83.2869L94.8662 74.2863L90.6241 50.9824Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7305 47.228L112.661 42.0379C114.96 41.4091 117.269 42.9764 117.541 45.3415L120.976 72.362L116.687 69.3962L98.4795 74.9993L93.7305 47.228Z",
    fill: "#363436"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.109 90.1477L73.2513 126.478C73.3639 127.032 73.6736 127.52 74.1429 127.839L76.4142 129.435C77.0148 129.857 77.7844 129.951 78.4696 129.679L126.288 110.852C127.086 110.542 127.621 109.791 127.668 108.937L129.216 79.8613C129.254 79.1386 128.935 78.4535 128.362 78.0124L117.56 69.7345C116.987 69.3028 116.246 69.1714 115.561 69.3873L98.6481 74.812C98.5918 74.8308 98.5355 74.8495 98.4792 74.8683L67.4042 87.6981C66.4469 88.0923 65.8932 89.1153 66.0996 90.1383L66.109 90.1477Z",
    fill: "#414042"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0527 99.4956L76.2916 128.562C76.3292 129.407 77.1832 129.97 77.9716 129.66L127.01 110.561C127.47 110.383 127.77 109.951 127.799 109.463L129.112 79.3734C129.15 78.5005 128.296 77.8623 127.47 78.1533L77.6337 95.6946C76.0288 96.2577 74.987 97.8062 75.0621 99.4956H75.0527Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 84.4597L77.998 101.629L78.3268 102.558L126.838 85.3887L126.509 84.4597Z",
    fill: "url(#paint1_linear_2551_5557)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2551_5557",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 97,
    width: 3,
    height: 2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5417 98.6811C77.8786 98.6811 78.1517 98.4079 78.1517 98.071C78.1517 97.7341 77.8786 97.4609 77.5417 97.4609C77.2048 97.4609 76.9316 97.7341 76.9316 98.071C76.9316 98.4079 77.2048 98.6811 77.5417 98.6811Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2551_5557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.185 97.4609H76.9316V98.6811H77.185V97.4609Z",
    fill: "#2484C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7956 97.4609H77.1855V98.6811H77.7956V97.4609Z",
    fill: "#2484C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1516 97.4609H77.7949V98.6811H78.1516V97.4609Z",
    fill: "#2484C6"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5411 99.1681C76.931 99.1681 76.4336 98.6706 76.4336 98.0606C76.4336 97.4505 76.931 96.9531 77.5411 96.9531C78.1511 96.9531 78.6485 97.4505 78.6485 98.0606C78.6485 98.6706 78.1511 99.1681 77.5411 99.1681ZM77.5411 97.948C77.4754 97.948 77.4284 98.0043 77.4284 98.0606C77.4284 98.192 77.6631 98.192 77.6631 98.0606C77.6631 97.9949 77.6068 97.948 77.5505 97.948H77.5411Z",
    fill: "url(#paint2_linear_2551_5557)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9419 109.2L74.2286 98.228C74.1441 96.8859 74.97 95.647 76.2371 95.2059L127.847 77.4863L128.166 78.4249L76.5561 96.1445C75.7021 96.4354 75.1483 97.2707 75.214 98.1623L75.9273 109.134L74.9419 109.2Z",
    fill: "url(#paint3_linear_2551_5557)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0176 36.66L90.3711 32.5586L114.304 41.944L93.7311 47.2279L93.4402 45.7638L73.0176 36.66Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7168 72.2966C75.4582 70.6635 75.2611 68.3829 76.256 66.9469L78.0298 72.6626C77.3447 72.3529 76.7253 71.9212 76.1997 71.3768C76.0964 71.283 75.965 71.2266 75.8243 71.2266C75.5333 71.236 75.3081 71.48 75.3174 71.771C75.3174 71.9024 75.3738 72.0338 75.477 72.1276C78.3395 74.7931 80.3574 74.1736 81.859 72.8128C82.5817 72.0901 83.051 71.1516 83.1918 70.1473C83.3795 68.5612 83.8487 67.022 84.5714 65.6048L85.6413 69.068C85.2847 68.8897 84.9374 68.6832 84.5996 68.4486C84.4869 68.3735 84.3462 68.3359 84.2054 68.3641C83.9238 68.4204 83.7361 68.702 83.7924 68.9835C83.8206 69.1149 83.8957 69.2275 84.0083 69.312C85.8666 70.6635 88.2036 71.0859 89.3204 70.4383C89.5738 70.2975 89.6489 69.969 89.5081 69.725C89.3674 69.4903 89.0764 69.3965 88.8324 69.5185L86.9365 63.418C87.2181 63.3711 87.4152 63.1083 87.3683 62.8174C87.3213 62.5546 87.0867 62.3575 86.8239 62.3762C84.3462 62.808 82.7037 66.1022 82.15 69.9878C82.0749 70.4852 81.906 70.9638 81.6526 71.3956L79.9538 65.9239C80.4231 66.1398 80.8454 66.4495 81.1927 66.8343C81.493 67.1628 81.8778 67.6602 82.3283 67.2566C82.7507 66.8061 82.2438 66.4213 81.9341 66.0928C81.2396 65.342 80.3292 64.8352 79.325 64.6475C77.3165 64.3753 75.2987 65.0135 74.4446 68.824C74.2569 69.7813 74.2287 70.6729 73.8533 71.602C73.7501 71.8836 73.6375 72.1558 73.5061 72.4374L72.652 69.6687C72.8303 69.7719 72.9993 69.8751 73.1494 69.9784C73.3934 70.1379 73.7219 70.0628 73.8815 69.8282C73.9566 69.7156 73.9847 69.5748 73.9566 69.4434C73.9284 69.312 73.8533 69.19 73.7313 69.1149C72.4643 68.2421 70.4371 67.388 68.7195 67.9511C68.4474 68.0356 68.2878 68.3265 68.3723 68.5987C68.4567 68.8709 68.7477 69.0305 69.0199 68.946C69.1513 68.9085 69.292 68.8709 69.4328 68.8521L71.3099 74.9245C71.1879 74.9902 71.0565 75.0371 70.9251 75.084C70.6529 75.1685 70.4934 75.4594 70.5778 75.741C70.6623 76.0226 70.9533 76.1727 71.2348 76.0883C73.0837 75.5157 74.1443 73.7044 74.7074 72.2966H74.7168ZM85.3223 64.5161C85.5193 64.2815 85.7446 64.075 85.9886 63.8873L87.7906 69.6968C87.4903 69.6874 87.1806 69.6405 86.8896 69.556L85.3223 64.5161ZM77.0819 66.0834C77.5793 65.755 78.1706 65.5954 78.7713 65.6423L80.8454 72.3247C80.3855 72.7001 79.8036 72.9066 79.203 72.916L77.0819 66.0834ZM72.2203 74.3144L70.5309 68.8803C70.8125 68.9272 71.094 68.9929 71.3662 69.0868L72.7834 73.6668C72.6145 73.9015 72.4268 74.1173 72.2203 74.3144Z",
    fill: "#00AEEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2551_5557",
    x1: 34.7246,
    y1: 51.7323,
    x2: 129.057,
    y2: 106.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2551_5557",
    x1: 77.9802,
    y1: 93.5231,
    x2: 126.831,
    y2: 93.5229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2551_5557",
    x1: 76.4336,
    y1: 98.07,
    x2: 78.6485,
    y2: 98.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2551_5557",
    x1: 74.2192,
    y1: 93.3476,
    x2: 128.176,
    y2: 93.3476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img4.11401ea332b252794fb6fafbf96fae74.svg";
export { ForwardRef as ReactComponent };